export const categoryFormUploader = (data) => {
  const formdata = new FormData();

  formdata.append('name', data.name);
  formdata.append('description', data.description || '');
  formdata.append('status', data.is_active);

  if (data.image && data.image.length > 0) {
    formdata.append('image', data.image[0]);
  }

  return formdata;
};